import { Injectable } from '@angular/core';

import { InlineAddConfig, InlineAddField } from './inline-add-panel.component';

@Injectable({
  providedIn: 'root'
})
export class SupplierAddConfigService {
  
  getSupplierConfig(): InlineAddConfig {
    return {
      modelType: 'supplier',
      title: 'Supplier',
      apiEndpoint: 'api/suppliers/create',
      submitButtonText: 'Save', 
      cancelButtonText: 'Cancel',
      fieldMapping: {
        'supplierCode': 'code'
      },
      selectionConfig: {
        targetField: 'supplierId',
        valueField: 'id',
        labelField: 'name'
      },
      fields: [
        {
          name: 'name',
          label: 'Supplier Name',
          type: 'text',
          required: true,
          isInstantData: true,
          maxLength: 250,
          placeholder: 'Enter supplier name',
          size: 'full'
        },
        {
          name: 'controlAccountId',
          label: 'Control Acc.',
          type: 'select',
          required: true,
          options: [],
          placeholder: 'Select control account',
          size: 'half',
          searchConfig: {
            url: "api/accountcodes/search",
            searchFields: ['code', 'name'],
            defaultFilter: "IsActive eq true and SpecialCode eq 'CCAC'"
          }
        },
        {
          name: 'supplierCode',
          label: 'Supplier Code',
          type: 'text',
          required: true,
          maxLength: 20,
          placeholder: 'Auto-generated by system',
          size: 'half'
        },
        {
          name: 'currencyId',
          label: 'Currency',
          type: 'select',
          required: true,
          options: [],
          placeholder: 'Select currency',
          size: 'half',
          searchConfig: {
            url: 'api/currencies/lookup',
            searchFields: ['code'],
            defaultFilter: ''
          }
        },
        {
          name: 'termId',
          label: 'Term',
          type: 'select',
          required: false,
          options: [],
          placeholder: 'Select term',
          size: 'half',
          searchConfig: {
            url: 'api/terms/lookup',
            searchFields: ['code', 'description'],
            defaultFilter: ''
          }
        },
        {
          name: 'purchaserId',
          label: 'Purchaser',
          type: 'select',
          required: false,
          options: [],
          placeholder: 'Select purchaser',
          size: 'half',
          searchConfig: {
            url: 'api/purchasers/lookup',
            searchFields: ['code', 'name']
          }
        }
      ]
    };
  }
} 